import {
    DEFAULT_DIALOG_HEIGHT,
    EFFECTIVE_BOTTOM_BOUNDARY_OFFSET,
    FLAG_POPUP_DISTANCE,
    FLAG_POPUP_WIDTH,
    QRM_PANEL_WIDTH_VW,
    TOOLBAR_HEIGHT,
    VW_DIVISOR,
} from '../../../shared/constants/sizes'

export interface FlagBounds {
    top: number
    right: number
    bottom: number
    left: number
}

export const calculateVerticalPosition = (
    flagBounds: FlagBounds,
    containerBounds: DOMRect,
    dialogHeight = DEFAULT_DIALOG_HEIGHT
): number => {
    const { top: flagTop, bottom: flagBottom } = flagBounds

    const containerTop = containerBounds.top + TOOLBAR_HEIGHT
    const containerBottom = containerBounds.top + containerBounds.height - EFFECTIVE_BOTTOM_BOUNDARY_OFFSET

    const spaceAbove = flagTop - containerTop
    const spaceBelow = containerBottom - flagBottom

    const fitsBelow = flagTop + dialogHeight <= containerBottom
    const fitsAbove = spaceAbove >= dialogHeight

    const top = !fitsBelow && fitsAbove && spaceAbove > spaceBelow ? flagBottom - dialogHeight : flagTop

    const maxTop = containerBottom - dialogHeight

    return Math.max(containerTop, Math.min(top, maxTop))
}

export const calculateHorizontalPosition = (flagBounds: FlagBounds, containerBounds: DOMRect): number => {
    const { left: flagLeft, right: flagRight } = flagBounds

    const qrmPanelWidth = Math.max((window.innerWidth * QRM_PANEL_WIDTH_VW) / VW_DIVISOR, 360)
    const qrmPanelLeft = window.innerWidth - qrmPanelWidth

    const defaultLeft = flagRight + FLAG_POPUP_DISTANCE
    const defaultPopupRight = defaultLeft + FLAG_POPUP_WIDTH

    const chosenLeft =
        defaultPopupRight > qrmPanelLeft - FLAG_POPUP_DISTANCE
            ? flagLeft - FLAG_POPUP_WIDTH - FLAG_POPUP_DISTANCE
            : defaultLeft

    const minLeft = containerBounds.left + FLAG_POPUP_DISTANCE
    const maxLeft = containerBounds.right - qrmPanelWidth - FLAG_POPUP_DISTANCE - FLAG_POPUP_WIDTH

    return Math.max(minLeft, Math.min(chosenLeft, maxLeft))
}
